module.exports = __webpack_public_path__ + "static/media/BreastCancer_FFE2874.dc58387d.jpg";